import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface IWalletDrawerState {
  isOpen: boolean;
}

const initialState: IWalletDrawerState = {
  isOpen: false,
};

const walletDrawerSlice = createSlice({
  name: 'walletDrawer',
  initialState,
  reducers: {
    setWalletDrawerOpen: (state: IWalletDrawerState, { payload }: PayloadAction<boolean>) => {
      state.isOpen = payload;
    },
    toggleWalletDrawer: (state: IWalletDrawerState) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const walletDrawerActions = walletDrawerSlice.actions;
export const walletDrawerReducer = walletDrawerSlice.reducer;
